import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import set from 'ember-set-helper/helpers/set';
import classNames from 'volta/helpers/class-names';
interface BvFiltersConnectedFilterControlItemSignature {
    Blocks: {
        default: [];
    };
}
export default class BvFiltersConnectedFilterControlItemComponent extends Component<BvFiltersConnectedFilterControlItemSignature> {
    @tracked
    focused = false;
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    <div
      class={{classNames
        'bv-filters-connected-filter-control-item'
        (if this.focused 'bv-filters-connected-filter-control-item--focused')
      }}
      {{on 'blur' (set this 'focused' false)}}
      {{on 'focus' (set this 'focused' true)}}
    >
      {{yield}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvFilters::ConnectedFilterControlItem': typeof BvFiltersConnectedFilterControlItemComponent;
        'bv-filters/connected-filter-control-item': typeof BvFiltersConnectedFilterControlItemComponent;
    }
}
